import React from "react";
import { Phone } from "lucide-react";

export default function EmergencyBanner() {
  return (
    <div
      data-testid="emergency-banner"
      className="w-full bg-[#2C1E23] text-[#FAF7F2] text-xs sm:text-sm"
    >
      <div className="max-w-[1400px] mx-auto px-6 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-center">
        <div className="flex items-center gap-2">
          <Phone className="w-3.5 h-3.5 text-[#C5A059]" />
          <span className="tracking-[0.14em] uppercase font-medium">
            Violences conjugales — appelez le{" "}
            <a
              href="tel:3919"
              data-testid="helpline-3919"
              className="text-[#C5A059] sdm-link-underline font-semibold"
            >
              3919
            </a>{" "}
            · anonyme & gratuit · 24h/24
          </span>
        </div>
        <span className="hidden sm:inline-block opacity-40">|</span>
        <span className="opacity-75">
          Danger immédiat : composez le{" "}
          <a href="tel:17" className="text-[#C5A059] font-semibold sdm-link-underline">
            17
          </a>
        </span>
      </div>
    </div>
  );
}
